/*
Ravi 02/23/2023 2780168262 implemented test functionality
Sohel 02/24/2023 3075154998 change file Size validation
Guru Prasad 03/23/2023 3075154998 Implemented new UI changes
Akhila 5/22/2023 3075154998 implemented warning toast message validation on diffrent file
*/
import React, {useEffect, useState} from 'react';
import {Box, Button, List, ListItem, Typography, Tooltip} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import {useDropzone} from 'react-dropzone';
const useStyles = makeStyles((theme) => ({
  // boxDrop: {
  //   // padding: 12,
  // },
  previewImg: {
    maxHeight: '1122px !important',
    maxWidth: '794px !important',
    height: 'auto',
    width: 'auto',
  },
  fileText: {
    margin: '10px 0 0',
    fontSize: '12px',
    fontWeight: 700,
    color: '#000000',
  },
  extendedIcon: {
    marginRight: theme.spacing(3),
    marginBottom: '7px',
  },
  uploadText: {
    fontSize: '17px !important',
    // paddingTop: "10px",
    [theme.breakpoints.down('md')]: {
      fontSize: '13px !important',
    },
  },
  uploadContent: {
    fontSize: '17px !important',
    // paddingBottom: "10px",
    [theme.breakpoints.down('md')]: {
      fontSize: '13px !important',
    },
  },
  filePara: {
    textAlign: 'center !important',
    marginTop: '15px !important',
  },
  actionButton: {
    textTransform: 'capitalize',
    fontSize: '0.9rem',
    color: '#056c93',
    fontWeight: 600,
    padding: '5px 30px 5px 30px',
    borderRadius: '5px',
    backgroundColor: 'transparent',

    outline: 'none',
    border: '2px solid #056c93',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      marginTop: '10px',
    },
  },
}));

const DragAndDrop = ({
  setFieldValue,
  error,
  helperText,
  uploadedFile,
  addHospital,
  logoFile,
  capturedImages,
  fileSizeError,
  setFileSizeError,
  enableTest = false,
  isLetter = false,
  warningOpen,
  setWarningOpen,
}) => {
  const classes = useStyles();
  const [files, setFiles] = useState('');
  const fileFormat = enableTest ?
    'text/csv,text/plain' :
    isLetter ?
      'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document' :
      'image/jpeg, image/png, image/jpg, application/pdf, .doc, .docx, .txt';
  const maxSize = enableTest || isLetter ? 10485760n : 5242880n;
  const fileSize = enableTest || isLetter ? '10MB' : '5MB';
  const {getRootProps, getInputProps, open, acceptedFiles, isDragReject, fileRejections} =
    useDropzone({
      noClick: true,
      noKeyboard: true,
      multiple: false,
      accept: fileFormat,
      maxSize: maxSize,
      onDrop: (acceptedFiles) => {
        setFieldValue('uploadedFile', acceptedFiles);
      },
    });
  useEffect(() => {
    if (uploadedFile == null) {
      acceptedFiles.splice(0, 1);
      setFiles([]);
    } else if (uploadedFile.length === 0) {
      setWarningOpen(true);
    }
  }, [uploadedFile]);

  useEffect(() => {
    const files = acceptedFiles.map((file, i) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {};
      const remove = (file) => {
        acceptedFiles.splice(file, 1);
        setFiles([]);
        setFieldValue('uploadedFile', null);
      };
      return (
        <ListItem key={file.path}>
          {i + 1}.{file.path}
          <Tooltip title="Delete">
            <DeleteRoundedIcon style={{cursor: 'pointer'}} onClick={() => remove(i)} />
          </Tooltip>
        </ListItem>
      );
    });

    setFiles(files);
  }, [acceptedFiles, setFieldValue]);
  const isFileTooLarge =
    fileRejections && fileRejections.length > 0 && fileRejections[0].file.size > maxSize;

  useEffect(() => {
    if (isFileTooLarge) {
      setFileSizeError(isFileTooLarge);
    } else {
      setFileSizeError(false);
    }
  }, [isFileTooLarge, setFileSizeError]);
  return (
    <>
      <Box className={classes.boxDrop}>
        <Box {...getRootProps({className: 'dropzone'})}>
          <input {...getInputProps()} />
          <Typography className={classes.uploadText}>Drag and drop files here</Typography>
          <Typography className={classes.uploadContent}>Or</Typography>
          <Button
            variant="outlined"
            disabled={capturedImages && capturedImages.length}
            onClick={open}
            className={classes.actionButton}
          >
            Browse
          </Button>
          {!addHospital && !enableTest && !isLetter && (
            <span className={classes.filePara}>
              <em className="mt-3">1.Total File size should be under 5MB</em>
              <br />
              <em>
                2.File type supported are: &apos;jpg&apos;, &apos;jpeg&apos;, &apos;png&apos;, &apos;pdf&apos;,
                 &apos;JPG&apos;, &apos;JPEG&apos;, &apos;PNG&apos;, &apos;PDF&apos;,
                &apos;docx&apos;, &apos;doc&apos;, &apos;txt&apos;
              </em>
            </span>
          )}

          {isDragReject && !enableTest && !isLetter && (
            <div className="text-danger mt-2">
              <em>
                File type not supported, only supported file are : &apos;jpg&apos;, &apos;jpeg&apos;, &apos;png&apos;, &apos;pdf&apos;,
                &apos;JPG&apos;, &apos;JPEG&apos;, &apos;PNG&apos;, &apos;PDF&apos;
              </em>
            </div>
          )}
          {enableTest && (
            <div className="mt-2">
              <em>only supported file are : &apos;.csv&apos;, &apos;.txt&apos;</em>
            </div>
          )}
          {isLetter && (
            <div className="text-primary mt-2">
              <em>only supported file are : &apos;.doc&apos;, &apos;.docx&apos;</em>
            </div>
          )}
          {fileSizeError && (
            <div className="text-danger mt-2">
              <em>File size is too large, file size should be under {fileSize}</em>
            </div>
          )}
          {error && (
            <div className="mt-2">
              <p className="mb-0 text-danger">{helperText}</p>
            </div>
          )}
        </Box>
        <aside>
          <List>{files}</List>
        </aside>
      </Box>
    </>
  );
};

export default DragAndDrop;
